import instance from "./instance";
import errorTips from "../message/index";
import ossProgress from "../upload-progress";
import { CONSTS } from "../consts";
import { setMaxDigits } from "./encryptList/bigInt";
import { RSAKeyPair, encryptedString } from "./encryptList/rsa";
import { randomMixed, DES } from "./encryptList/des";

const whiteUrls = [
  "/Login",
  "/file/fileinfo",
  "/file/addFile",
  "/file/sts",
  "/get-key",
];

const OSS = require("ali-oss");

const PARTSIZE = 1 * 1024 * 1024;
let temporaryToken;

const getRequest = (url, data, header) => {
  if (!whiteUrls.includes(url)) {
    url = "/SGFNCWEBSITE" + url;
  }
  let newData;
  if (data) {
    newData = Object.assign(data, {
      times: Math.random(),
    });
  } else {
    newData = {
      times: Math.random(),
    };
  }
  return instance
    .get(
      url,
      {
        params: newData,
      },
      {
        headers: header,
      }
    )
    .catch((err) => {
      errorTips(err);
    });
};

const postRequest = (url, data, header) => {
  if (!whiteUrls.includes(url)) {
    url = "/SGFNCWEBSITE" + url;
  }
  data = data ? data : {};

  return instance
    .post(url, data, {
      headers: header,
    })
    .catch((err) => {
      errorTips(err);
    });
};

function uploadFile(path) {
  const formData = new FormData();
  formData.append("file", path);

  return instance
    .post("/SGFNCWEBSITE/framework/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .catch(() => {
      errorTips("Uncaught FailError: The file/files upload failed");
    });
}

function generateClient() {
  if (temporaryToken) {
    return new OSS({ ...temporaryToken });
  }
}

function createToken(isTried) {
  return axios.post("/file/sts").then((res) => {
    if (res) {
      const { endpoit, keyId, keySecret, securityToken, region, bucket } = res;
      temporaryToken = {
        region,
        endpoint: endpoit,
        accessKeyId: keyId,
        accessKeySecret: keySecret,
        stsToken: securityToken,
        bucket,
      };
    } else if (isTried) {
      return createToken(true);
    }
  });
}

async function downloadFile(info) {
  console.log(info);
  await createToken();

  const client = generateClient();

  const { filePath, origName } = info;
  return client.signatureUrl(filePath, {
    response: {
      "content-disposition": `attachment; filename="${origName}"`,
    },
  });
}

function transformFileToBlob(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    let blob = null;
    reader.onload = function(e) {
      if (typeof e.target.result === "object") {
        blob = new Blob([e.target.result]);
      } else {
        blob = e.target.result;
      }
      resolve(blob);
    };
    reader.onerror = function(err) {
      reject(err);
    };
  }).catch(() => {});
}

function commonUpload(path, file, progress) {
  const client = generateClient();
  const name = file.name;

  return transformFileToBlob(file).then((res) => {
    // progress(1, name);
    return client.put(path, res);
  });
}

function multipartUpload(path, file, progress) {
  const client = generateClient();
  let tempCheckpoint;

  return client.multipartUpload(path, file, {
    progress: function(percentage, checkpoint) {
      tempCheckpoint = checkpoint;
      // progress(percentage, file.name);
    },
    checkpoint: tempCheckpoint,
  });
}

// 多文件上传
async function multipleUploadFile(files, status = "idArr") {
  const fileInfoArr = [];
  const idArr = [];

  files = files.map((fileItem) => {
    const file = fileItem.file || fileItem;
    fileInfoArr.push({
      fileName: file.name,
      fileSize: file.size,
    });
    return file;
  });

  const fileInfos = await axios.post("/file/addFile", fileInfoArr);
  if (!fileInfos) {
    return false;
  }

  await createToken();

  // ossProgress.show();

  const progress = ossProgress.progress;
  const tasks = files.map((file) => {
    const { size, name } = file;
    const { objectKey, fileId } = fileInfos[`${name}_${size}`];

    status == "idArr" && idArr.push(fileId);
    status == "fileArr" && idArr.push({ fileid: fileId, filenm: name });
    if (size > PARTSIZE) {
      return multipartUpload(objectKey, file, progress);
    } else {
      return commonUpload(objectKey, file, progress);
    }
  });
  return Promise.all(tasks).then((res) => {
    // ossProgress.hide();
    temporaryToken = null;
    return res && idArr;
  });
}

const ossThumbnailStack = [];

async function ossThumbnail(path, id, cb) {
  if (temporaryToken) {
    generateSignatureUrl(path, cb);
  } else {
    cb &&
      ossThumbnailStack.push({
        path,
        id,
        cb,
      });
    createToken().then(() => {
      if (temporaryToken) {
        let i = ossThumbnailStack.length;
        while (i--) {
          const { path, id, cb } = ossThumbnailStack[i];
          generateSignatureUrl(path, id, cb);
          ossThumbnailStack.pop();
        }
        // 清空temporaryToken
        temporaryToken = null;
      }
    });
  }
}

function generateSignatureUrl(path, id, cb) {
  const client = generateClient();
  const signUrl = client.signatureUrl(path, {
    expires: 3600,
    process: "image/resize,w_1000",
  });
  cb && cb(signUrl, id);
}

function encryptRequest(url, data = {}) {
  let encrypt, des;
  let publicKey = null;
  let keyTimestamp = null;
  return getRequest("/get-key", "getKey").then((res) => {
    console.log(res, "res");
    if (res) {
      setMaxDigits(130);
      publicKey = new RSAKeyPair(res.exponent, "", res.modulus);
      keyTimestamp = res.timestamp;
      encrypt = randomMixed(6);
      des = new DES();
      let newData = Object.assign({}, data);
      for (let key in newData) {
        newData[key] = des.strEnc("" + newData[key], encrypt);
      }
      newData["_ENCRYPT_KEY_"] = encryptedString(publicKey, encrypt);
      newData["_ENCRYPT_TIMESTAMP_"] = keyTimestamp;
      return postRequest(url, newData).then((result) => {
        if (result) {
          return JSON.parse(des.strDec(result, encrypt));
        }
      });
    }
  });
}

const axios = {
  get: getRequest,
  post: postRequest,
  file: multipleUploadFile,
  single: uploadFile,
  downfile: downloadFile,
  encrypt: encryptRequest,
};

export default axios;



// WEBPACK FOOTER //
// ./src/untils/axios/index.js